import { render, staticRenderFns } from "./UserManagers.vue?vue&type=template&id=05abfa2b&"
import script from "./UserManagers.vue?vue&type=script&lang=js&"
export * from "./UserManagers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports